export const requestTypes = [
  { id: "Sell", name: "Sell" },
  { id: "Buy", name: "Buy" },
];

export const sortByOptions = [
  { id: "match_confidence", name: "Sort By: Match Confidence" },
  { id: "message_date", name: "Sort By: Message Date" },
];

export const initialRegionOptions = [
  { id: "all", name: "All" },
  { id: "uk", name: "UK" },
  { id: "europe", name: "Europe" },
  { id: "usa", name: "USA" },
  { id: "asia", name: "Asia" },
  { id: "middle-east", name: "Middle East" },
  { id: "africa", name: "Africa" },
  { id: "north-america", name: "North America" },
  { id: "south-america", name: "South America" },
  { id: "australia", name: "Australia" },
];

export const initialMessageTypeOptions = [
  { id: "single", name: "Single Product Messages" },
  { id: "multiple", name: "Multi Product Messages" },
  { id: "all", name: "Both Product Messages" },
];

export const tabOptions = [
  { id: "whatsapp", name: "WhatsApp" },
  { id: "marketplace", name: "Marketplace" },
];
